/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Faceta API
 * API мультитенантного admin-движка Faceta. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ConstantBody,
  ConstantUpdateHeaders,
  ConstantsOutputBody,
  CreateConstantInputBody,
  ErrorModel,
  ReorderConstantsInputBody,
  UpdateConstantInputBody
} from '../model';

import { facetaFetch } from '../../http';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type constantDeleteResponse204 = {
  data: void
  status: 204
}

export type constantDeleteResponse401 = {
  data: ErrorModel
  status: 401
}

export type constantDeleteResponse403 = {
  data: ErrorModel
  status: 403
}

export type constantDeleteResponse404 = {
  data: ErrorModel
  status: 404
}

export type constantDeleteResponse422 = {
  data: ErrorModel
  status: 422
}

export type constantDeleteResponse500 = {
  data: ErrorModel
  status: 500
}

export type constantDeleteResponseSuccess = (constantDeleteResponse204) & {
  headers: Headers;
};
export type constantDeleteResponseError = (constantDeleteResponse401 | constantDeleteResponse403 | constantDeleteResponse404 | constantDeleteResponse422 | constantDeleteResponse500) & {
  headers: Headers;
};

export type constantDeleteResponse = (constantDeleteResponseSuccess | constantDeleteResponseError)

export const getConstantDeleteUrl = (constantId: string,) => {




  return `/constants/${constantId}`
}

/**
 * Насовсем: сайт перестанет получать значение по этому ключу.
 * @summary Удалить константу
 */
export const constantDelete = async (constantId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<constantDeleteResponse> => {

  return facetaFetch<constantDeleteResponse>(getConstantDeleteUrl(constantId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getConstantDeleteQueryKey = (constantId: string,) => {
    return [
    'DELETE', `/constants/${constantId}`
    ] as const;
    }


export const getConstantDeleteQueryOptions = <TData = Awaited<ReturnType<typeof constantDelete>>, TError = ErrorModel>(constantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConstantDeleteQueryKey(constantId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof constantDelete>>> = ({ signal }) => constantDelete(constantId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: constantId !== null && constantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof constantDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConstantDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof constantDelete>>>
export type ConstantDeleteQueryError = ErrorModel


export function useConstantDelete<TData = Awaited<ReturnType<typeof constantDelete>>, TError = ErrorModel>(
 constantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof constantDelete>>,
          TError,
          Awaited<ReturnType<typeof constantDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConstantDelete<TData = Awaited<ReturnType<typeof constantDelete>>, TError = ErrorModel>(
 constantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof constantDelete>>,
          TError,
          Awaited<ReturnType<typeof constantDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConstantDelete<TData = Awaited<ReturnType<typeof constantDelete>>, TError = ErrorModel>(
 constantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Удалить константу
 */

export function useConstantDelete<TData = Awaited<ReturnType<typeof constantDelete>>, TError = ErrorModel>(
 constantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConstantDeleteQueryOptions(constantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type constantUpdateResponse200 = {
  data: ConstantBody
  status: 200
}

export type constantUpdateResponse401 = {
  data: ErrorModel
  status: 401
}

export type constantUpdateResponse403 = {
  data: ErrorModel
  status: 403
}

export type constantUpdateResponse404 = {
  data: ErrorModel
  status: 404
}

export type constantUpdateResponse409 = {
  data: ErrorModel
  status: 409
}

export type constantUpdateResponse412 = {
  data: ErrorModel
  status: 412
}

export type constantUpdateResponse422 = {
  data: ErrorModel
  status: 422
}

export type constantUpdateResponse428 = {
  data: ErrorModel
  status: 428
}

export type constantUpdateResponse500 = {
  data: ErrorModel
  status: 500
}

export type constantUpdateResponseSuccess = (constantUpdateResponse200) & {
  headers: Headers;
};
export type constantUpdateResponseError = (constantUpdateResponse401 | constantUpdateResponse403 | constantUpdateResponse404 | constantUpdateResponse409 | constantUpdateResponse412 | constantUpdateResponse422 | constantUpdateResponse428 | constantUpdateResponse500) & {
  headers: Headers;
};

export type constantUpdateResponse = (constantUpdateResponseSuccess | constantUpdateResponseError)

export const getConstantUpdateUrl = (constantId: string,) => {




  return `/constants/${constantId}`
}

/**
 * Значение правит редактор; ключ, вид и название — тот, кто меняет устройство сайта.
 * @summary Изменить константу
 */
export const constantUpdate = async (constantId: string,
    updateConstantInputBody: NonReadonly<UpdateConstantInputBody>,
    headers: ConstantUpdateHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<constantUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<constantUpdateResponse>(getConstantUpdateUrl(constantId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(updateConstantInputBody)
  }
);}





export const getConstantUpdateQueryKey = (constantId: string,
    updateConstantInputBody?: NonReadonly<UpdateConstantInputBody>,) => {
    return [
    'PATCH', `/constants/${constantId}`, updateConstantInputBody
    ] as const;
    }


export const getConstantUpdateQueryOptions = <TData = Awaited<ReturnType<typeof constantUpdate>>, TError = ErrorModel>(constantId: string,
    updateConstantInputBody: NonReadonly<UpdateConstantInputBody>,
    headers: ConstantUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConstantUpdateQueryKey(constantId,updateConstantInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof constantUpdate>>> = ({ signal }) => constantUpdate(constantId,updateConstantInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: constantId !== null && constantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof constantUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConstantUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof constantUpdate>>>
export type ConstantUpdateQueryError = ErrorModel


export function useConstantUpdate<TData = Awaited<ReturnType<typeof constantUpdate>>, TError = ErrorModel>(
 constantId: string,
    updateConstantInputBody: NonReadonly<UpdateConstantInputBody>,
    headers: ConstantUpdateHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof constantUpdate>>,
          TError,
          Awaited<ReturnType<typeof constantUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConstantUpdate<TData = Awaited<ReturnType<typeof constantUpdate>>, TError = ErrorModel>(
 constantId: string,
    updateConstantInputBody: NonReadonly<UpdateConstantInputBody>,
    headers: ConstantUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof constantUpdate>>,
          TError,
          Awaited<ReturnType<typeof constantUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConstantUpdate<TData = Awaited<ReturnType<typeof constantUpdate>>, TError = ErrorModel>(
 constantId: string,
    updateConstantInputBody: NonReadonly<UpdateConstantInputBody>,
    headers: ConstantUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Изменить константу
 */

export function useConstantUpdate<TData = Awaited<ReturnType<typeof constantUpdate>>, TError = ErrorModel>(
 constantId: string,
    updateConstantInputBody: NonReadonly<UpdateConstantInputBody>,
    headers: ConstantUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConstantUpdateQueryOptions(constantId,updateConstantInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type constantsListResponse200 = {
  data: ConstantsOutputBody
  status: 200
}

export type constantsListResponse401 = {
  data: ErrorModel
  status: 401
}

export type constantsListResponse403 = {
  data: ErrorModel
  status: 403
}

export type constantsListResponse404 = {
  data: ErrorModel
  status: 404
}

export type constantsListResponse422 = {
  data: ErrorModel
  status: 422
}

export type constantsListResponse500 = {
  data: ErrorModel
  status: 500
}

export type constantsListResponseSuccess = (constantsListResponse200) & {
  headers: Headers;
};
export type constantsListResponseError = (constantsListResponse401 | constantsListResponse403 | constantsListResponse404 | constantsListResponse422 | constantsListResponse500) & {
  headers: Headers;
};

export type constantsListResponse = (constantsListResponseSuccess | constantsListResponseError)

export const getConstantsListUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/constants`
}

/**
 * Телефон, почта, ссылки на соцсети — значения, которые сайт берёт по ключу.
 * @summary Константы окружения
 */
export const constantsList = async (id: string,
    kind: 'production' | 'development', options?: Parameters<typeof facetaFetch>[1]): Promise<constantsListResponse> => {

  return facetaFetch<constantsListResponse>(getConstantsListUrl(id,kind),
  {
    ...options,
    method: 'GET'


  }
);}





export const getConstantsListQueryKey = (id: string,
    kind: 'production' | 'development',) => {
    return [
    `/sites/${id}/environments/${kind}/constants`
    ] as const;
    }


export const getConstantsListQueryOptions = <TData = Awaited<ReturnType<typeof constantsList>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantsList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConstantsListQueryKey(id,kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof constantsList>>> = ({ signal }) => constantsList(id,kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof constantsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConstantsListQueryResult = NonNullable<Awaited<ReturnType<typeof constantsList>>>
export type ConstantsListQueryError = ErrorModel


export function useConstantsList<TData = Awaited<ReturnType<typeof constantsList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof constantsList>>,
          TError,
          Awaited<ReturnType<typeof constantsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConstantsList<TData = Awaited<ReturnType<typeof constantsList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof constantsList>>,
          TError,
          Awaited<ReturnType<typeof constantsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConstantsList<TData = Awaited<ReturnType<typeof constantsList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantsList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Константы окружения
 */

export function useConstantsList<TData = Awaited<ReturnType<typeof constantsList>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantsList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConstantsListQueryOptions(id,kind,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type constantCreateResponse201 = {
  data: ConstantBody
  status: 201
}

export type constantCreateResponse401 = {
  data: ErrorModel
  status: 401
}

export type constantCreateResponse403 = {
  data: ErrorModel
  status: 403
}

export type constantCreateResponse404 = {
  data: ErrorModel
  status: 404
}

export type constantCreateResponse409 = {
  data: ErrorModel
  status: 409
}

export type constantCreateResponse422 = {
  data: ErrorModel
  status: 422
}

export type constantCreateResponse500 = {
  data: ErrorModel
  status: 500
}

export type constantCreateResponseSuccess = (constantCreateResponse201) & {
  headers: Headers;
};
export type constantCreateResponseError = (constantCreateResponse401 | constantCreateResponse403 | constantCreateResponse404 | constantCreateResponse409 | constantCreateResponse422 | constantCreateResponse500) & {
  headers: Headers;
};

export type constantCreateResponse = (constantCreateResponseSuccess | constantCreateResponseError)

export const getConstantCreateUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/constants`
}

/**
 * Ключ один на окружение: второй «phone» — 409.
 * @summary Завести константу
 */
export const constantCreate = async (id: string,
    kind: 'production' | 'development',
    createConstantInputBody: NonReadonly<CreateConstantInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<constantCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<constantCreateResponse>(getConstantCreateUrl(id,kind),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createConstantInputBody)
  }
);}





export const getConstantCreateQueryKey = (id: string,
    kind: 'production' | 'development',
    createConstantInputBody?: NonReadonly<CreateConstantInputBody>,) => {
    return [
    'POST', `/sites/${id}/environments/${kind}/constants`, createConstantInputBody
    ] as const;
    }


export const getConstantCreateQueryOptions = <TData = Awaited<ReturnType<typeof constantCreate>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    createConstantInputBody: NonReadonly<CreateConstantInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConstantCreateQueryKey(id,kind,createConstantInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof constantCreate>>> = ({ signal }) => constantCreate(id,kind,createConstantInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof constantCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConstantCreateQueryResult = NonNullable<Awaited<ReturnType<typeof constantCreate>>>
export type ConstantCreateQueryError = ErrorModel


export function useConstantCreate<TData = Awaited<ReturnType<typeof constantCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    createConstantInputBody: NonReadonly<CreateConstantInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof constantCreate>>,
          TError,
          Awaited<ReturnType<typeof constantCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConstantCreate<TData = Awaited<ReturnType<typeof constantCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    createConstantInputBody: NonReadonly<CreateConstantInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof constantCreate>>,
          TError,
          Awaited<ReturnType<typeof constantCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConstantCreate<TData = Awaited<ReturnType<typeof constantCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    createConstantInputBody: NonReadonly<CreateConstantInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Завести константу
 */

export function useConstantCreate<TData = Awaited<ReturnType<typeof constantCreate>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    createConstantInputBody: NonReadonly<CreateConstantInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConstantCreateQueryOptions(id,kind,createConstantInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type constantsReorderResponse204 = {
  data: void
  status: 204
}

export type constantsReorderResponse401 = {
  data: ErrorModel
  status: 401
}

export type constantsReorderResponse403 = {
  data: ErrorModel
  status: 403
}

export type constantsReorderResponse404 = {
  data: ErrorModel
  status: 404
}

export type constantsReorderResponse422 = {
  data: ErrorModel
  status: 422
}

export type constantsReorderResponse500 = {
  data: ErrorModel
  status: 500
}

export type constantsReorderResponseSuccess = (constantsReorderResponse204) & {
  headers: Headers;
};
export type constantsReorderResponseError = (constantsReorderResponse401 | constantsReorderResponse403 | constantsReorderResponse404 | constantsReorderResponse422 | constantsReorderResponse500) & {
  headers: Headers;
};

export type constantsReorderResponse = (constantsReorderResponseSuccess | constantsReorderResponseError)

export const getConstantsReorderUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/constants/order`
}

/**
 * @summary Порядок констант
 */
export const constantsReorder = async (id: string,
    kind: 'production' | 'development',
    reorderConstantsInputBody: NonReadonly<ReorderConstantsInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<constantsReorderResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<constantsReorderResponse>(getConstantsReorderUrl(id,kind),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reorderConstantsInputBody)
  }
);}





export const getConstantsReorderQueryKey = (id: string,
    kind: 'production' | 'development',
    reorderConstantsInputBody?: NonReadonly<ReorderConstantsInputBody>,) => {
    return [
    'PUT', `/sites/${id}/environments/${kind}/constants/order`, reorderConstantsInputBody
    ] as const;
    }


export const getConstantsReorderQueryOptions = <TData = Awaited<ReturnType<typeof constantsReorder>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development',
    reorderConstantsInputBody: NonReadonly<ReorderConstantsInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantsReorder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConstantsReorderQueryKey(id,kind,reorderConstantsInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof constantsReorder>>> = ({ signal }) => constantsReorder(id,kind,reorderConstantsInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof constantsReorder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ConstantsReorderQueryResult = NonNullable<Awaited<ReturnType<typeof constantsReorder>>>
export type ConstantsReorderQueryError = ErrorModel


export function useConstantsReorder<TData = Awaited<ReturnType<typeof constantsReorder>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    reorderConstantsInputBody: NonReadonly<ReorderConstantsInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantsReorder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof constantsReorder>>,
          TError,
          Awaited<ReturnType<typeof constantsReorder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConstantsReorder<TData = Awaited<ReturnType<typeof constantsReorder>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    reorderConstantsInputBody: NonReadonly<ReorderConstantsInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantsReorder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof constantsReorder>>,
          TError,
          Awaited<ReturnType<typeof constantsReorder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useConstantsReorder<TData = Awaited<ReturnType<typeof constantsReorder>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    reorderConstantsInputBody: NonReadonly<ReorderConstantsInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantsReorder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Порядок констант
 */

export function useConstantsReorder<TData = Awaited<ReturnType<typeof constantsReorder>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development',
    reorderConstantsInputBody: NonReadonly<ReorderConstantsInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof constantsReorder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getConstantsReorderQueryOptions(id,kind,reorderConstantsInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






